import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AOS from "aos";
import "aos/dist/aos.css";

import { ASSETS } from "./assetsBase";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Marquee from "./components/Marquee";
// import Clients from "./components/Clients";
import Process from "./components/Process";
// import Testimonials from "./components/Testimonials";
import WhyLozrian from "./components/WhyLozrian";
// import Team from "./components/Team";
import Contact from "./components/Contact";
// import Blog from "./components/Blog";
import Footer from "./components/Footer";

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

const STYLESHEETS = [
  "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Ubuntu:wght@300;400;500;700&display=swap",
  `${ASSETS}/fonts/fontawesome/css/all.min.css`,
  `${ASSETS}/css/plugins/bootstrap.min.css`,
  `${ASSETS}/css/plugins/slick.css`,
  `${ASSETS}/css/plugins/aos.css`,
  `${ASSETS}/css/spacings.css`,
  `${ASSETS}/css/style.css`,
  `${ASSETS}/css/lozrian-overrides.css`,
];

function useTemplateStyles() {
  useEffect(() => {
    const links = STYLESHEETS.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.setAttribute("data-orbia-style", "true");
      document.head.appendChild(link);
      return link;
    });
    document.body.classList.add("orbia-page-body");
    return () => {
      links.forEach((link) => document.head.removeChild(link));
      document.body.classList.remove("orbia-page-body");
    };
  }, []);
}

function OrbiaPage() {
  useTemplateStyles();
  const smootherRef = useRef(null);

  useEffect(() => {
    AOS.init({ offset: 0 });
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (!hash || hash === "#") return;
      const target = document.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      const smoother = smootherRef.current;
      if (smoother) {
        smoother.scrollTo(target, true, "top top");
      } else {
        target.scrollIntoView({ behavior: "smooth" });
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useGSAP(() => {
    smootherRef.current = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      smoothTouch: 0.1,
    });
    return () => {
      smootherRef.current?.kill();
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <>
      <Header />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            <Hero />
            <About />
            <Services />
            <Marquee />
            {/* <Clients /> */}
            <Process />
            {/* <Testimonials /> */}
            <WhyLozrian />
            {/* <Team /> */}
            <Contact />
            {/* <Blog /> */}
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default OrbiaPage;
